const bannerCounter = () => {
    const counter = document.querySelector('.banner-counter');

    if (!counter) return;

    function QuantityPlaces(value, startDate) {
        const stepDay = new Date().getDate() - startDate;

        if (stepDay <= 0) {
            return value;
        } else {
            return value - stepDay * 2;
        }
    }

    counter.innerHTML = QuantityPlaces(16, 29);
}

export default bannerCounter;